<template>
  <select
    class="form-control"
    :value="modelValue"
    @input="$emit('update:modelValue', parseInt($event.target.value))"
  >
    <option
      v-for="parada in paradas"
      :key="parada.id"
      :value="parada.id"
      :selected="parada.id == modelValue"
    >
      {{ parada.nombre }}
    </option>
  </select>
</template>

<script>
import { sortBy } from 'lodash';
import { transporte } from 'cifra-api-js';
import { dateToTimeString } from '../../../libs/dates';

export default {
  props: {
    turnoId: {
      type: [Number, Array],
      default: () => [],
    },
    modelValue: { type: Number, default: 0 },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      paradas: [],
    };
  },
  computed: {
    turnosOrdenados() {
      return sortBy(this.turnos, ['ruta.nombre', 'nombre']);
    },
  },
  watch: {
    turnoId(value) {
      this.$emit('update:modelValue', 0);
      this.loadParadas(value);
    },
  },
  mounted() {
    if (this.turnoId) {
      this.loadParadas(this.turnoId);
    }
  },
  methods: {
    loadParadas(turnoId) {
      if (!turnoId || (Array.isArray(turnoId) && !turnoId.length)) {
        this.paradas = [];
        this.$emit('update:modelValue', 0);
        return;
      }

      const params = {
        turno_id: turnoId,
      };

      transporte.paradas.get({ params }).then((result) => {
        this.paradas = result.data;
        if (!this.modelValue && this.paradas.length > 0) {
          this.$emit('update:modelValue', this.paradas[0].id);
        }
      });
    },
    dateToTimeString,
  },
};
</script>
